/**
 * La fachada de San Diego 820, de frente y retocada para que el nombre se lea
 * entero y sin autos. 1600 px en WebP: alcanza para la banda del inicio y la
 * cabecera de `/nuestra-tienda` aun en pantallas de alta densidad.
 *
 * Es la cabecera fija de `/nuestra-tienda` (no se edita) y el respaldo de la
 * banda del inicio mientras el panel no suba otra (Portada → Foto de la
 * tienda).
 *
 * Las copias achicadas (`-480w`…) se generaron a mano con `sharp`, como las que
 * el backend hace al subir (`almacen/variantes.ts`): si cambia la foto, se
 * regeneran.
 */
import type { FotoTienda } from '@elcarpintero/compartido';

/**
 * Ancho de la foto en la banda (`inicio.css`): 45 % del contenedor en
 * escritorio, la pantalla entera bajo 720 px. Vale para cualquier foto de la
 * banda, la de respaldo o la subida en el panel.
 */
export const TAMANOS_FOTO_TIENDA = '(max-width:720px) 100vw, 600px';

export const FOTO_FACHADA: FotoTienda = {
  url: '/tienda/fachada-san-diego.webp',
  ancho: 1600,
  alto: 1102,
  variantes: [320, 480, 800, 1200].map((ancho) => ({
    url: `/tienda/fachada-san-diego-${String(ancho)}w.webp`,
    ancho,
  })),
};
